import { useBookEditor } from "./BookEditorProvider";

/** Turn 1 stub — Write/Canvas bring their own rails; Design/Preview use this. */
export default function BookEditorToolRail() {
  const { mode } = useBookEditor();
  if (mode === "write" || mode === "canvas") return null;
  return (
    <aside className="book-editor-tool-rail" data-testid="book-editor-tool-rail">
      <span className="book-editor-rail-label">Tools</span>
    </aside>
  );
}
